import distinctColors from 'distinct-colors'

const colors = distinctColors({
  count: 100,
  hueMin: 0,
  hueMax: 360,
  chromaMin: 0,
  chromaMax: 85,
  lightMin: 30,
  lightMax: 95,
}).map((e) => e.hex())

export default colors
